import { render, staticRenderFns } from "./ConcernRelatedCompanyPopover.vue?vue&type=template&id=3b92a90a"
import script from "./ConcernRelatedCompanyPopover.vue?vue&type=script&lang=js"
export * from "./ConcernRelatedCompanyPopover.vue?vue&type=script&lang=js"
import style0 from "./ConcernRelatedCompanyPopover.vue?vue&type=style&index=0&id=3b92a90a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports